import type { IPublicDesktopV2OffersGetOffersByPinResponse } from 'shared/repositories/commercial-listing-map/desktop/v2/offers/get-offers-by-pin';
import { ISortOptionSchema } from 'shared/repositories/commercial-listing-map/entities/sort_option/SortOptionSchema';

export function sortOptionsFromGetOffersByPinSelector(
  state: IPublicDesktopV2OffersGetOffersByPinResponse,
): ISortOptionSchema[] {
  return state.sortingProperties.sortOptions;
}
